import { redirect, type MiddlewareFunction } from "react-router";

import type { FeatureSwitch } from "@skilitics/designer-auth/features";
import { getFeatureSwitch } from "@skilitics/designer-auth/state";

export const navigateToModules: MiddlewareFunction = async () => {
  throw redirect("/modules");
};

export const requireFeatureSwitch =
  (name: FeatureSwitch): MiddlewareFunction =>
  (_args, next) => {
    if (!getFeatureSwitch(name)) {
      throw redirect("/modules");
    }
    return next();
  };
